import { configureStore } from "@reduxjs/toolkit";
import adminReducer from "./adminSlices";

const store = configureStore({
  reducer: adminReducer,
});

export default store;
